import React, { Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { useTranslation } from 'react-i18next'

import { Heading } from '../../components/Text/Heading'
import { makeStyles } from '@material-ui/core/styles'
import { NavigateBack } from '@/components/Nav/NavigateBack'
import { navigate } from '@reach/router'

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    backgroundColor: '#fff',
    borderRadius: '15px',
  },

  headingContainer: {
    width: '100%',
  },

  internalContainer: {
    padding: '0 4rem 2rem 4rem',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },

  navigateBackContainer: {
    paddingTop: '1rem',
    marginTop: 0,
  },

  p: {
    whiteSpace: 'pre',
  },
}))

const WhatIsDokiApp = () => {
  const { t }: { t: any } = useTranslation('whatIsDokiApp')
  const classes = useStyles()

  const handleNavigateBack = () => {
    navigate('/')
  }

  return (
    <Fragment>
      <Grid item xs={12} className={classes.dashboardContainer}>
        <NavigateBack
          onBack={handleNavigateBack}
          className={classes.navigateBackContainer}
        />

        <div className={classes.internalContainer}>
          <div className={classes.headingContainer}>
            <Heading>{t('heading')}</Heading>
          </div>

          <p>{t('text1')}</p>
          <p>{t('text2')}</p>
          <p className={classes.p}>{t('text3')}</p>
        </div>
      </Grid>
    </Fragment>
  )
}

export { WhatIsDokiApp }
